import { Instance, SnapshotOrInstance, types } from "mobx-state-tree";

const {
    enumeration,
    literal,
    model,
    string,
    union,
} = types;


export const SensorDisplayPrecip = model({
    type: literal("precip"),
    interval: string,
    measure: enumeration("precip", ["total", "intensity"]),
});
export interface ISensorDisplayPrecip
    extends Instance<typeof SensorDisplayPrecip> { }

export const SensorDisplayStream = model({
    type: literal("stream"),
    period: string,
    measure: enumeration("stream", ["stage", "discharge"]),
});
export interface ISensorDisplayStream
    extends Instance<typeof SensorDisplayStream> { }

export const SensorDisplay = union(SensorDisplayPrecip, SensorDisplayStream);
export type SensorDisplay_ = SnapshotOrInstance<typeof SensorDisplay>;
